import { debounce } from "lodash";
import { useState, useEffect } from "react";

export function useDebouncedValue<T>(value: T, delay: number): T {
	const [debouncedValue, setDebouncedValue] = useState(value);

	useEffect(() => {
		const handler = debounce(() => setDebouncedValue(value), delay);
		handler();

		// Cleanup to cancel debounce if value changes quickly
		return () => {
			handler.cancel();
		};
	}, [value, delay]);

	return debouncedValue;
}